module.exports = __webpack_public_path__ + "static/media/apple_car_play.9b488de0.jpg";